import { Creditor } from '../Entity/Creditor';
import { Case } from './Case';
import { CaseCreditorStatus } from '../Status/CaseCreditorStatus';

export class CaseCreditorListFilter {
  search?: string;
  start_date?: string | Date;
  end_date?: string | Date;
  status_date_type?: 'sign_up' | 'change_date';
  case_creditor_statuses?: Array<number>;
  select_all?: boolean | 0 | 1; // paginated or return all
  only_count?: boolean | 0 | 1;
  only_related?: boolean | 0 | 1;
  case_creditor_status_ids?: Array<number>;
  amount_paid?: number;
  creditor_ids?: number;
  statuses?: Array<number>;
  case_status_ids?: Array<number>;
  case_creditor_ids?: Array<number>;
  expected_count?: number;
  creditor_types?: Array<string>;
  reduction_percentage?: number;
  settlement_funds?: number;
  activity_status?: string;
  product_ids?: Array<number>;
  cases?: Array<number>;
  creditors?: Array<number>;
  days_in_status?: number;
  can_settle?: Array<string>;

  // Sort
  order?: 'asc' | 'desc';
  sort_by?: 'id' | 'ref_number' | 'first_name' | 'last_name' | 'joint_application' | 'created_at' | 'last_action_at' | 'status' |
    'payment_status' | 'affiliate' | 'product' | 'debt_amount' | 'pending_files_count' | 'call_status';

  // Paginate
  per_page?: number;
  page?: number;

  // Relations
  case: Case;
  creditor?: Creditor;
  case_creditor_status: CaseCreditorStatus;
}
